import _ from 'lodash';

export const prettyPrice = (price) => {
  if (price === _.round(price)) {
    return price;
  }

  if (typeof price.toFixed === 'function') {
    return price.toFixed(2);
  }

  return price;
};

export const prettyTax = (salesTax) => {
  const salesTaxDollars = Math.floor(salesTax);
  const salesTaxCents = (salesTax - salesTaxDollars).toFixed(2).replace("0.", "");

  return { wholeDollarAmount: salesTaxDollars, remainderAmount: salesTaxCents };
};

export const prettyPriceTotal = (price) => {
  const priceTotalDollars = Math.floor(price);
  const priceTotalCents = (price - priceTotalDollars).toFixed(2).replace("0.", "");

  return { wholeDollarAmount: priceTotalDollars, remainderAmount: priceTotalCents };
};
